import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { MAIN_SITE_URL } from '@/mocks/categories';

export default function Footer() {
  const { t } = useTranslation();
  const year = new Date().getFullYear();

  return (
    <footer className="border-t border-background-200 bg-background-100">
      <div className="mx-auto w-full max-w-7xl px-4 py-12 md:px-6">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-4">
          <div className="md:col-span-2">
            <Link to="/" className="flex items-center gap-2 text-foreground-950">
              <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-grid-line"></i>
              </span>
              <span className="font-heading text-lg font-bold">{t('brand')}</span>
            </Link>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-600">
              {t('footer.description')}
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-foreground-950">
              {t('footer.explore')}
            </h4>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li>
                <Link to="/#categories" className="text-foreground-600 transition-colors hover:text-primary-700">
                  {t('footer.categories')}
                </Link>
              </li>
              <li>
                <Link to="/#articles" className="text-foreground-600 transition-colors hover:text-primary-700">
                  {t('footer.guides')}
                </Link>
              </li>
              <li>
                <Link to="/#faq" className="text-foreground-600 transition-colors hover:text-primary-700">
                  {t('footer.faq')}
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-foreground-950">
              {t('footer.resources')}
            </h4>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li>
                <a
                  href={MAIN_SITE_URL}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-foreground-600 transition-colors hover:text-primary-700"
                >
                  {t('footer.mainWebsite')}
                </a>
              </li>
              <li>
                <Link to="/article/usfans-spreadsheet-guide" className="text-foreground-600 transition-colors hover:text-primary-700">
                  {t('articles.readMore')}
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 border-t border-background-200 pt-6">
          <p className="text-xs leading-relaxed text-foreground-500">{t('footer.disclaimer')}</p>
          <p className="mt-4 text-xs text-foreground-500">
            © {year} {t('brand')}. {t('footer.rights')}
          </p>
        </div>
      </div>
    </footer>
  );
}